export function NotFound() {
    return (
        <div className="bg-primary" style={{ minHeight: "100vh" }}>
            <h1 className="text-l text-center p-2 bg-primary">
                Route is not available.
            </h1>
        </div>
    );
}
